import { registerMessages } from "../../i18n/runtime";
import { reportsNavEn } from "./messages.en";
import { reportsNavEs } from "./messages.es";

// Imported by the module definition, not by the lazy screens: the sidebar needs these labels before any screen has loaded.
registerMessages("en", reportsNavEn);
registerMessages("es", reportsNavEs);
